export default [
  [
    value =>
      /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(
        value
      ),
    'Please enter correct UUID',
  ],
]
